import React from "react";
import {useFormContext} from "react-hook-form";
import {TextFieldSuggestions} from "packages/react-hook-form-mui";

export default function FormTextFieldSuggestions({name, ...props}) {
  const {register, formState: {errors, isSubmitting}} = useFormContext();

  return (
    <TextFieldSuggestions
      name={name}
      register={register}
      errors={errors}
      disabled={isSubmitting}
      {...props}
    />
  );
}
